import { useChannelTalk } from '@repo/channel-talk';
import { Button, Description } from '@zenterprise-inc/ui';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { useBizMessageRequestType } from '@/lib/hooks/use-biz-message-request-type';

const SuccessContent = () => {
  const { requestType } = useBizMessageRequestType();
  const { openChannelTalk } = useChannelTalk();

  const subTitle = {
    recollect: '환급 신고에 필요한 자료를\n모두 수집하였어요!',
    checkDecision: '국세청에서\n환급이 결정되었어요!',
    job_retention: '확인에 필요한 자료 수집이\n완료되었어요!'
  };
  const description = {
    recollect: '신고 완료 후 알림톡으로 안내해드릴게요.',
    checkDecision: '자세한 내용은 영업일 기준 2일 내에\n카카오톡 알림톡으로 안내해드릴게요.',
    job_retention: '자료 수집 결과는 카카오톡 알림톡으로\n안내해드릴게요.'
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center pb-[108px]">
      <Description>
        <Description.Guide
          imgChild={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_check_sm.svg`} className={'w-20'} alt={''} />}
          subTitle={subTitle[requestType]}
          description={description[requestType]}
        />
      </Description>
      {requestType === 'checkDecision' && (
        <div className={'full-width text-14 absolute bottom-0 pb-12 pl-7 pr-7 text-gray-700'}>
          <span className={'mr-2.5'}>궁금하신 점이 있으시면 문의해주세요.</span>
          <Button.Box
            state={'secondary'}
            size={'small'}
            onClick={() => {
              openChannelTalk(SUPPORT_BOT_LINK.환급결정확인);
            }}
          >
            문의하기
          </Button.Box>
        </div>
      )}
    </div>
  );
};

export default SuccessContent;
